import * as React from 'react';
import { LifeCycleTypes, useFormEffects } from '@formily/react';
import { useFormInstance } from '.';
import { useContentName } from './useContentName';
export const useData = props => {
  const form = useFormInstance();
  const {
    name
  } = useContentName(props);
  const path = name.toString();
  const [val, setVal] = React.useState(path === '' ? form.getFormState(s => s.values) : form.getFieldValue(name));
  useFormEffects($ => {
    if (path === '') {
      $(LifeCycleTypes.ON_FORM_CHANGE).subscribe(s => {
        const value = s.values;
        setVal(value);
      });
      return;
    }

    $(LifeCycleTypes.ON_FIELD_VALUE_CHANGE, path).subscribe(s => {
      const value = s.value;
      setVal(value);
    });
    $(LifeCycleTypes.ON_FIELD_VALUE_CHANGE, path + '.*').subscribe(() => {
      const value = form.getFieldValue(path);
      setVal(value);
    });
  });
  return {
    value: val
  };
};
//# sourceMappingURL=es/hooks/useData.js.map